import mobx, { extendObservable, action } from 'mobx';
import axios from 'axios';
import { includes, map } from 'lodash';
import eb from '../utils/EventBus'
import fileDownload from 'react-file-download';
import {properties} from '../environments';

const BLOCK_CHAIN_URL = properties.BLOCKCHAIN_URL;

class RvwDocStore {

    constructor() {
        extendObservable(this, {
            loading: true,
            filteredDocs: [],
            docs:[],
            selectedDoc: {},
            searchTerm: '',
            newComment: '',
            newCmtFlag: '',
            username: null,
            orgName: null
        });

        eb.on('search-reviewdoc', (val) => this.setSearch(val));
    }


   loadRvwDocs = () => {
        axios.get('/api/v1/rvwdoc/docs').then(({ data }) => {
            this.loading = false;
            this.docs = data;
            this.filteredDocs = data;
        });
    }

   loadRvwDoc = (docId) => {

        axios.get(`/api/v1/rvwdoc/${docId}`).then(({ data }) => {
            this.loading = false;
            this.selectedDoc = data;
        });
    }

   updRvwDoc = () => {

        if ((this.newComment === null) || (this.newComment ==="") || (this.newComment===undefined))
        {
                  this.newComment=null;
                  this.newCmtFlag='N';
        }
         else {
                this.newCmtFlag='Y';
         }


        axios.post('/api/v1/rvwdoc/update', {
            docDetail: this.selectedDoc,
            newCom: this.newComment,
            newComFlag: this.newCmtFlag
        })
            .then((response) => {
                this.loadRvwDocs();
                this.newComment=null;
                eb.emit('toast', {
                    status: 'success',
                    text: 'Document updated'
                })
                eb.emit('doc-updated');
            });
    }

    updRvwFlag = (docIds) => {

        const docsRvwd = Object.keys(docIds).filter(i => docIds[i]=== true);
        const data = {docuIds: docsRvwd};

        //console.log(data);

        if (docsRvwd.length===0){
            alert('Please select atleast one record by clicking the checkbox');
            return false;
        }


        axios.post('/api/v1/rvwdoc/rvwflagupd',data).then((response) => {
            this.loadRvwDocs();
                    eb.emit('toast', {
                    status: 'success',
                    text: 'Review Acknowledgment saved'
                })
                eb.emit('Review Acknowledgment saved');
            });
    }


    setDocName = action((val) => {
        console.log(val)
        this.selectedDoc.docname = val;
    })

    setDocDescr = action((val) => {
        console.log(val)
        this.selectedDoc.docdescr = val;
    })

    setDocType = action((val) => {
        console.log(val)
        this.selectedDoc.doctype = val;
    })

    setComments = action((val) => {
        console.log(val)
        this.selectedDoc.comments = val;
    })

    setTag = action((val) => {
        console.log(val)
        this.selectedDoc.tag = val;
    })

     setNewComments = action((val) => {
        console.log(val)
        this.newComment = val;
    })

    getOrgUser = () => {
      // Get user email and org name first
            axios.get('/api/v1/uldoc/orgemail')
              .then((response) => {
               this.username = response.data.updatedby;
               this.orgName = response.data.orgname;
             });

    }

     // Get the BC token

    getBlockChainToken = (username, orgName) => {
      return new Promise((resolve, reject) => {
        axios.post(`${BLOCK_CHAIN_URL}/api/v1/auth_user`, {
            username,
            orgName
        })
            .then(function (response) {
                console.log(response);
                resolve(response.data);
            })
            .catch(function (error) {
                console.log(error);
                reject(error);
            });
     });

    }

    dwnld= async ( req, res) =>  {


            let fileId = this.selectedDoc.docid;

            // Get BC token
            const token = await this.getBlockChainToken(this.username, this.orgName);

            // Set up the input params needed for download from BC in options variable
            const options = {
                method: 'GET',
                headers: { 'Authorization': `Bearer ${token.token}`, 'Content-Type': 'application/json' },
                url: `${BLOCK_CHAIN_URL}/api/v1/download_file/${fileId}`
            };

            //console.log(options);

            // End point call using AJAX
            axios(options).then((response) => {
                   fileDownload(new Buffer(response.data), this.selectedDoc.docname);
            }).catch(err => {
                    console.log(err);
            });

    }

   setSearch = action((val) => {
        this.searchTerm = val;
        this.filteredDocs = this.docs.filter(i => JSON.stringify(i).toLowerCase().indexOf(val.toLowerCase()) > -1);
   })

}

const rvwstore = new RvwDocStore();
export default rvwstore;



// WEBPACK FOOTER //
// ./src/store/rvwdoc-store.js